package kz.dentalcrm.app.data.network.response_model.diagnosis

import androidx.compose.runtime.Immutable
import kotlinx.serialization.Serializable

@Serializable
@Immutable
data class Diagnosis(
    val code: String? = null,
    val id: Int,
    val name: String? = null,
    val organization_id: Int? = null
)